import { Search } from 'lucide-react';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Empty, EmptyIcon, EmptyTitle, EmptyDescription } from '@/components/ui/empty';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

import { useZebelApiIntegration } from '@/data/zebelApiIntegration';

const ViewZebelApiIntegrationDetailsDialog = ({ onClose, companyUid }) => {
  const zebelApiIntegration = useZebelApiIntegration(companyUid);

  let content = (
    <Empty>
      <EmptyIcon>
        <Search />
      </EmptyIcon>
      <EmptyTitle>No Zebel API Integration</EmptyTitle>
      <EmptyDescription>No Zebel API integration installed for this company</EmptyDescription>
    </Empty>
  );

  if (zebelApiIntegration.data) {
    const integration = zebelApiIntegration.data;
    content = (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Status</TableHead>
            <TableHead>Installed</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow key={integration.uid}>
            <TableCell>
              <Badge variant="success">{integration.status}</Badge>
            </TableCell>
            <TableCell>
              {new Date(integration.create_ts).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Zebel API Integration Details</DialogTitle>
          <DialogDescription>View the details of the Zebel API integration.</DialogDescription>
        </DialogHeader>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default ViewZebelApiIntegrationDetailsDialog;
